import { createSelector } from '@reduxjs/toolkit'

const studioSettings = ({ studioSettings }) => studioSettings

export const activeModeSelector = createSelector(
  studioSettings,
  ({ activeMode }) => activeMode
)

export const activeLeftPanelsSelector = createSelector(
  studioSettings,
  ({ activeLeftPanels }) => activeLeftPanels
)

export const activeRightPanelsSelector = createSelector(
  studioSettings,
  ({ activeRightPanels }) => activeRightPanels
)

export const currentZoomSelector = createSelector(
  studioSettings,
  ({ zoom }) => zoom
)

export const aiSettingsSelector = createSelector(
  studioSettings,
  ({ aiSettings }) => aiSettings
)

export const plgDemoSelector = createSelector(
  studioSettings,
  ({ plgDemo }) => plgDemo
)

export const downloadingTestPdfSelector = createSelector(
  studioSettings,
  ({ downloadingTestPdf }) => downloadingTestPdf
)

export const aiProgressSelector = createSelector(
  studioSettings,
  ({ aiProcessingProgress }) => aiProcessingProgress
)

export const aiActiveSelector = createSelector(
  studioSettings,
  ({ aiProcessingProgress }) => aiProcessingProgress.active
)

export const colorsSelector = createSelector(
  studioSettings,
  ({ colors }) => colors
)

export const fileNameSelector = createSelector(
  studioSettings,
  ({ fileName }) => fileName || 'Untitled PDF'
)

export const shouldInitializePagesSelector = createSelector(
  studioSettings,
  ({ shouldInitializePages }) => shouldInitializePages
)

export const replacingPdfSelector = createSelector(
  studioSettings,
  ({ replacingPdf }) => replacingPdf
)

export const tableWarningDisplayedSelector = createSelector(
  studioSettings,
  ({ tableWarningDisplayed }) => tableWarningDisplayed
)
